import axios from "axios";
import { useEffect, useState } from "react";


const usePosts = () => {
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        axios.get(`https://tripaide-server.onrender.com/posts`)
            .then(res => {
                setPosts(res.data);
            })
    }, []);
    return [posts, setPosts]
};

export default usePosts;